<template>
  <imgWithNoImageError
    :src="src"
    height="70px"
    width="70px"
    :class="'img-list-thumbnail'"
  />
</template>

<script>
import imgWithNoImageError from '@/components/img-with-no-image-error.vue'

export default {
  name: 'ImageCell',
  components: {
    imgWithNoImageError,
  },
  props: ['value'],
  computed: {
    src() {
      return this.value ? this.createFullFileAddress(this.value) : ''
    },
  },
  methods: {
    createFullFileAddress({
      baseUrl, bucketName, destination, filename,
    }) {
      return `${baseUrl + bucketName}/${destination}${filename}`
    },
  },
}
</script>
